import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button
} from "@mui/material";

type Props = {
  open: boolean;
  onClose: () => void;
};

export default function AddKataDialog({
  open,
  onClose,
}: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>
        Ajouter une équipe Kata
      </DialogTitle>

      <DialogContent>
        <TextField
          fullWidth
          label="Nom de l'équipe"
          margin="normal"
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>
          Annuler
        </Button>

        <Button
          variant="contained"
          color="error"
        >
          Ajouter
        </Button>
      </DialogActions>
    </Dialog>
  );
}